/**
 * @enum enumEducationalVideoItemType Represents different types of product video types.
 * (Note: Try to keep the enumerations in alphabetical order to simplify viewing.)
 */
export enum enumEducationalVideoItemType {
  Catalog = 'Catalog',  // A catalog that contains other catalogs and/or videos
  InformationalVideo = 'InformationalVideo',  // An informational video, such as a product overview
  TrainingVideo = 'TrainingVideo',  // A training video, such as a how-to video
}
